(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('movimentacao-demandas', {
            parent: 'app',
            url: '/movimentacao-demandas',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'Relatório das movimentações das demandas'
            },
            views: {
                'content@': {
                    templateUrl: 'app/relatorios/movimentacao-demandas/movimentacao-demandas.html',
                    controller: 'MovimentacaoDemandasController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('chamado');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    return $translate.refresh();
                }]
            }
        }).state('acumulo-demandas', {
            parent: 'app',
            url: '/acumulo-demandas',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'Relatório das movimentações das demandas'
            },
            views: {
                'content@': {
                    templateUrl: 'app/relatorios/movimentacao-demandas/acumulo-demandas.html',
                    controller: 'AcumuloDemandasController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('chamado');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    return $translate.refresh();
                }]
            }
        })
    }
})();
